// extracted by mini-css-extract-plugin
module.exports = {"reach-customers-container":"Marketing_reach-customers-container__2HMGm","reach-customers":"Marketing_reach-customers__2pLYO","prices":"Marketing_prices__28dlC"};